import { forwardRef } from 'react'
import type { IconProps } from '../icon-props'
import { Icon } from '../icon'
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGQ9Ik05LjQyOSAxOC4zOTcgMyAxMS45N2wxLjgxMy0xLjgxMyA0LjYxNiA0LjYwM0wxOS4xODcgNSAyMSA2LjgyNnoiLz48L3N2Zz4=) */
export const IconCheckBox = forwardRef<SVGElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path fill="#111928" d="M9.429 18.397 3 11.97l1.813-1.813 4.616 4.603L19.187 5 21 6.826z" />
    </Icon>
))
IconCheckBox.displayName = 'IconCheckBox'
